import type { SlideshowInterface } from '~/types/AppData/PageContent/SlideshowInterface';
import type { ArticleInterface } from '~/types/AppData/PageContent/ArticleInterface';

/**
 * Checks if a given article contains a slideshow.
 *
 * @param {ArticleInterface} article - The article object to check.
 * @param {SlideshowInterface} [slideshow] - The slideshow object to check.
 * @returns {boolean} True if the slideshow exists, has slide links, and
 *                    either the article doesn't have finite scroll or
 *                    has its finite scroll value set to 0. Otherwise, false.
 */
export const getHasSlideshow = (
  article: ArticleInterface,
  slideshow?: SlideshowInterface
): boolean => {
  return !!(
    slideshow &&
    slideshow.slidesLinks &&
    Object.keys(slideshow.slidesLinks).length &&
    (!article.finiteScrollNumber || article.finiteScrollNumber === 0)
  );
};
